<template>
    <div>
        <!-- <div :class="classForDOM.parent">
                <span class="text-lg font-normal mb-2" style="color: black">
                    {{ $t("information") }}
                </span>
            </div> -->

        <div
            :class="wMobile ? 'flex-col items-center' : ''"
            class="flex justify-between"
        >
            <div
                style="width: 50%"
                :class="wMobile ? 'items-center' : ''"
                class="flex flex-col justify-between"
            >
                <span class="font-semibold text-base pr-4 pb-2">
                    {{ data["admission_basis_name"] }}
                </span>
                <span class="text-base font-semibold pr-4">
                    {{ data["study_form_name"] }}
                </span>

                <!-- <span class="text-base font-semibold pr-4 pb-2">
                            {{ data["based_on_name"] }}
                        </span> -->
                <!-- <span class="text-base font-semibold pr-4 pb-2">
                            {{ data["budget_level_name"] }}
                        </span> -->
            </div>

            <div
            style="width: 50%"
                :class="wMobile ? ' items-center' : ''"
                class="flex flex-col justify-between"
            >
                <span class="text-base font-semibold pr-4 pb-2">
                    {{ data["education_program_group_name"] }}
                </span>
                <span class="text-base font-semibold pr-4">
                    {{ data["education_program_name"] }}
                </span>

                <!-- <span class="font-semibold text-base pr-4 pb-2">
                            {{ data["campaign_name"] }}
                        </span> -->
            </div>

            <div
            style="width: 25%"
                :class="wMobile ? 'items-center' : ''"
                class="flex flex-col justify-between"
            >
                <span class="text-base font-semibold pr-4">
                    {{ data["language_name"] }}
                </span>
                <span class="text-base font-semibold pr-4">
                    {{ data["preparation_level_name"] }}
                </span>
               

                <!-- <span class="text-base font-semibold pr-4 pb-2">
                            {{ data["entrance_test_form_name"] }}
                        </span> -->
            </div>
   
           <div
                style="width: 20%"
                :class="wMobile ? 'items-center' : ''"
                class="flex flex-col justify-between"
            >
             <span class="text-base font-semibold pr-4 pb-2">
                            {{ data["study_period_name"] }}
                        </span>
           </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DirectionForRender",
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        wMobile() {
            return window.innerWidth < 800;
        },
    },
    data() {
        return {
            classForDOM: {
                grandParent: "flex flex-col md:flex-row justify-between",
                parent: "flex flex-col md:flex-row justify-between items-start",
                block: "flex flex-col w-full",
            },
        };
    },
};
</script>

<style scoped lang="scss">
</style>
